import React from 'react'
import Icon1 from '../../images/starbucks-coffee.svg'
import Icon2 from '../../images/wal-mart.svg'
import Icon3 from '../../images/chipotle-mexican-grill.svg'
import Icon4 from '../../images/daimler-logo.svg'

const Moto = ({statement}) => {
  return (
    <div className="w-full bg-neutral-700 flex justify-content items-center pt-16 flex-col gap-10">
        <div className="w-4/5 mx-auto flex flex-col justify-content my-2">
        <h3 className="text-3xl pb-8 text-white">COJON</h3>
      
        <p className="leading-8 text-white font-light">
          COJON LLC was established in 2017 by John Demchek with years of engineering and project management experience in the construction industry and the goal of supplying the best quality steel work possible. In 2019 COJON began taking on larger commercial projects and thrived during the COVID lockdowns by being dependable. Most recently COJON worked with Sletten general contractors to supply and install a 7,500 sq ft addition to Walmart in Battle Ground, WA. We have also completed a 15,000 sq ft admin building and shop for the Sunrise Water Authority in Damascus, OR which consisted of over 2,000 hours of prevailing wage work. COJON has made a name for themselves in the area by safely supplying quality work at great pricing and on schedule.
        </p>
      
      </div>
   
      <div className="w-4/5 mx-auto flex flex-col justify-content my-2">
        <h3 className="text-3xl pb-8 text-white">If It's Worth Doing, It's Worth Doing Right</h3>
        <p className="leading-8 text-white font-light pb-8">
          {statement}
        </p>
        <p className="leading-8 text-white font-light">
          At COJON we take on the challenging projects and complete them safely, on time, on budget and with the highest quality possible.
        </p>
        <br/>
        <p className="leading-8 text-white font-light">
          We take pride in our work and stand out from the competition by putting in the time and effort to communicate and plan our projects with our customers. 
        </p>
      </div>
      <div className="flex justify-around w-full px-4 bg-white py-8">
        <img src={Icon1} alt="Icon 1" className="w-16 h-16" />
        <img src={Icon2} alt="Icon 1" className="w-16 h-16" />
        <img src={Icon3} alt="Icon 1" className="w-16 h-16" />
        <img src={Icon4} alt="Icon 1" className="w-16 h-16" />
      </div>
    </div>
  )
}

export default Moto